import { AxiosInstance } from "axios";
import {
  IFilterSchema,
  IListQueryStringSchema,
  ISortSchema,
} from "../../Schemas/ListQueryString";
import { IResponseBody } from "../../Schemas/EndPoint";
import { PbxCallDetailRecord } from "../../Schemas/PBXCallDetail";

interface Filter extends IFilterSchema {
  column: CallDetailListColumnFilterable;
}

interface Sort extends ISortSchema {
  column: CallDetailListColumnSortable;
}
export enum PbxCallDetailStatusEnum {
  CREATED = "created",
  WAITING_FOR_SEND = "waiting_for_send",
  SENDING = "sending",
  FAILED = "failed",
  ANSWERED = "answered",
  BLOCKED = "blocked",
  NO_ANSWER = "no_answer",
  BUSY = "busy",
  REJECTED = "rejected",
  UNREACHABLE = "unreachable",
  DEVICE_OFF = "device_off",
  INVALID_NUMBER = "invalid_number",
  CANCELED = "canceled",
}

export enum CallDetailListColumnFilterable {
  ID = "id",
  VOICE_BROADCAST_ID = "voice_broadcast_id",
  VOICE_BROADCAST_NUMBER_ID = "voice_broadcast_number_id",
  PARTNER_ID = "partner_id",
  PBX_SERVER_ID = "pbx_server_id",
  PBX_TRUNK_ID = "pbx_trunk_id",
  PBX_CHANNEL_REFERENCE_CODE = "pbx_channel_reference_code",
  NUMBER = "number",
  EXTENSION = "extension",
  PICKUP_TIME = "pickup_time",
  SCHEDULED_TIME = "scheduled_time",
  SENT_TIME = "sent_time",
  START_TIME = "start_time",
  ANSWER_TIME = "answer_time",
  END_TIME = "end_time",
  UNIQUE_ID = "unique_id",
  USER_FIELD = "user_field",
  CALLER_ID = "caller_id",
  WAITING_SECONDS = "waiting_seconds",
  BILLABLE_SECONDS = "billable_seconds",
  DURATION_SECONDS = "duration_seconds",
  STATUS = "status",
  CREATED_AT = "created_at",
  UPDATED_AT = "updated_at",
}
export enum CallDetailListColumnSortable {
  ID = "id",
  VOICE_BROADCAST_ID = "voice_broadcast_id",
  VOICE_BROADCAST_NUMBER_ID = "voice_broadcast_number_id",
  PARTNER_ID = "partner_id",
  PBX_SERVER_ID = "pbx_server_id",
  PBX_TRUNK_ID = "pbx_trunk_id",
  PBX_CHANNEL_REFERENCE_CODE = "pbx_channel_reference_code",
  NUMBER = "number",
  EXTENSION = "extension",
  PICKUP_TIME = "pickup_time",
  SCHEDULED_TIME = "scheduled_time",
  SENT_TIME = "sent_time",
  START_TIME = "start_time",
  ANSWER_TIME = "answer_time",
  END_TIME = "end_time",
  UNIQUE_ID = "unique_id",
  USER_FIELD = "user_field",
  CALLER_ID = "caller_id",
  WAITING_SECONDS = "waiting_seconds",
  BILLABLE_SECONDS = "billable_seconds",
  DURATION_SECONDS = "duration_seconds",
  STATUS = "status",
  CREATED_AT = "created_at",
  UPDATED_AT = "updated_at",
}

interface CallDetailListQueryString extends IListQueryStringSchema {
  filters?: Filter[];
  sorts?: Sort[];
}

interface CallDetailListResponseBody extends IResponseBody {
  data: {
    pbx_call_detail_records: PbxCallDetailRecord[];
    total: number;
  };
}

export class CallDetailListRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath() {
    return `/admin/pbx-call-detail-records`;
  }

  async list(
    queryStrings?: CallDetailListQueryString
  ): Promise<CallDetailListResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(this.getPath(), {
        params: queryStrings,
      });
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
